import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviReclamationState } from './state';

export const getters: GetterTree<SuiviReclamationState, RootState> = {
    getSuiviReclamationItems(state) {
        return state.reclamations;
    },
    getSuiviReclamationFilterSite(state): Array<number> {
        return state.filterSite;
    },
    getSuiviReclamationFilterStatus(state): Array<string> {
        return state.filterStatus;
    },
    getSuiviReclamationIsLoading(state) {
        return state.isLoading;
    },
    getSuiviReclamationPage(state) {
        return state.page;
    },
    getSuiviReclamationNbOfPages(state) {
        return state.nbOfPages;
    },
    getSuiviReclamationScroll(state) {
        return state.scroll;
    },
    getSuiviReclamationSort(state) {
        return state.sort;
    },
    getSuiviReclamationCount(state) {
        return state.count;
    },
    getSuiviReclamationTableHeader(state) {
        return state.tableHeader;
    },
    getHistoriqueItems(state) {
        return state.historiques;
    },
    getIsExportReclamationLoading(state) {
        return state.isExportLoading;
    },
};
